import { useRef } from 'react';
import { toast } from 'react-toastify';

const THROTTLE_MS = 2000;

export const useThrottledToast = () => {
  const lastToastTime = useRef<number>(0);

  const showToast = (type: 'success' | 'error') => {
    const now = Date.now();
    if (now - lastToastTime.current > THROTTLE_MS) {
      lastToastTime.current = now;
      if (type === 'success') {
        toast.success('Данные успешно сохранены');
      } else {
        toast.error('Произошла ошибка');
      }
    }
  };

  return showToast;
};
